module.exports = __webpack_public_path__ + "media/tenderfoot.c5ae5efb.webm";